import {
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";

import React, { useState } from "react";
import { baseUrl } from "../../constants";
import useAxios from "../../hooks/useAxios";
import CommandList from "../Importation/CommandList";
import { CommandListEntry } from "../../model/CommandEntry";

interface CryoResult {
  cryos: Array<string>;
  cryoProfondes: Array<string>;
  actifs: Array<string>;
  nouveaux: Array<string>;
}

const CryoManagerPage = () => {
  const [input, setInput] = useState("");
  const [axiosInstance] = useAxios();
  const [commands, setCommands] = useState<Array<CommandListEntry>>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setCommands([]);
    var names = Array.from(input.matchAll(/\[[^\[\]]+?\] ([^\[\]]+)/g))
      .map((x) => x[1])
      .map((y) => y.split("~"))
      .map((z) => ({ name: z[0], id: z.length > 1 ? z[1] : undefined }));
    setIsLoading(true);
    const results = await axiosInstance.post<CryoResult>(
      `${baseUrl}/cryogenie`,
      {
        cryos: names,
      }
    );
    setIsLoading(false);
    setTotalCount(results.data.nouveaux.length);
    setCommands(
      results.data.actifs.map((target, index) => ({
        id: target,
        index,
        command: `action ${target}`,
        lastModified: null,
      }))
    );
  };
  return (
    <>
      <Grid container>
        <Grid size={6}>
          <TextField
            label="Entrez le contenu du TP ici"
            variant="filled"
            fullWidth
            multiline
            value={input}
            onChange={(event) => setInput(event.target.value)}
            minRows={30}
            maxRows={30}
          ></TextField>
        </Grid>
        <Grid size={6}>
          {isLoading && (
            <Box sx={{ width: "100%", height: " 100%", display: "flex" }}>
              <CircularProgress
                sx={{ margin: "auto", alignContent: "center" }}
              />
            </Box>
          )}
          {commands.length > 0 && (
            <Box>
              <Typography variant="body1" sx={{ margin: "5px" }}>
                Personnages à valider
              </Typography>
              <CommandList
                fetch={() => undefined}
                commands={commands}
                totalCount={totalCount}
              />
            </Box>
          )}
        </Grid>
        <Button onClick={handleSubmit}>Soumettre</Button>
      </Grid>
    </>
  );
};

export default CryoManagerPage;
